export default __webpack_public_path__ + "static/media/Gallery-21.a64ddc19.jpeg";